import Vue from 'vue';

export default {
    state:{
      notificaciones:{
        web:[],
        notificacion:{
          idnotificacion:null,
          titulo:null,
          contenido:null,
          web:null,
          mobile:null,
          fecha_hora:null,
          origen:null,
          destino:null,
          estatus:null
        }
      }
    },
    mutations: {
      setNotificaciones(state,notificaciones){
        state.notificaciones.web=notificaciones;
      },
      setNotificacion(state,notificacion){
        state.notificaciones.notificacion=notificacion;
      },
    },
    actions: { 
      Actualizar_Notificaciones(context){
        Vue.http.get('notificaciones/web/'+context.rootState.menu.menu.usuario.cve_empleado+'/pendientes')
        .then(respuesta=>{return respuesta.json()})
        .then(respuestaJson=>{
          context.commit('setNotificaciones',respuestaJson);
        })
        .catch(error=>{
          console.log('Error en modulo notificaciones "Actualizar_Notificaciones"',error);
        });
      },
      Actualizar_Notificacion(context,notificacion){
        context.commit('setNotificacion',notificacion);
      },
      Ver_Notificacion(context,notificacion){
        context.commit('setNotificacion',notificacion);
        $('#button_modal_ver_notificacion').click();
      },
    },
    getters: {  
      getNotificaciones(state){
        var notificaciones_no_leidas=[];
        for (var i = 0; i < state.notificaciones.web.length; i++) {
          if (notificaciones_no_leidas.length<5) {
            if (state.notificaciones.web[i].estatus==1) {
              notificaciones_no_leidas.push(state.notificaciones.web[i]);
            }
          }
        }
        return notificaciones_no_leidas;
      },
      getNotificacion(state){
        return state.notificaciones.notificacion;
      },
      getTotalNotificaciones_No_Leidas(state){
        var notificaciones_no_leidas=[];
        for (var i = 0; i < state.notificaciones.web.length; i++) {
          
            if (state.notificaciones.web[i].estatus==1) {
              notificaciones_no_leidas.push(state.notificaciones.web[i]);
            }
          
        }
        return notificaciones_no_leidas.length;
      },
    },
    
}


// WEBPACK FOOTER //
// ./src/modules/notificaciones.js